import { Component, Input, forwardRef, Inject } from '@angular/core';

import { CompanyService } from '../companies/company.service';
import { SessionService } from '../sessions/session.service';

@Component({
  selector: 'wor-loan-car-activate',
  template: require('./loan-car-schedule.activate.component.html')
})
export class LoanCarActivateComponent {
  @Input() settings: any;

  session: any;

  constructor(
    @Inject(forwardRef(() => CompanyService))
    public companyService: CompanyService,
    @Inject(forwardRef(() => SessionService))
    private sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.session = this.sessionService.base();
  }

  subscriptionUpgrade(): void {
    window.location.href = '#/subscription_type_upgrade';
  }
}
